import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { getActiveRouteForNavigation, getRouteObject } from '@/helpers/routing';

const useActiveRoutes = () => {
  const { asPath } = useRouter();
  
  const routeKey = (getRouteObject(asPath) || {}).key;
  // Gets an object which flags which route is active
  const activeRoutesObject = useMemo(() => getActiveRouteForNavigation({ routeKey }), [routeKey]);

  return activeRoutesObject;
};

export default useActiveRoutes;